import { videos } from "@/mocks/videos";

export function formatPlayCount(count: number): string {
  if (count >= 100000000) {
    return `${(count / 100000000).toFixed(1)}亿`;
  }
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
  return `${count}`;
}

export function getVideoById(id: string | undefined) {
  if (!id) return undefined;
  return videos.find((item) => item.id === id);
}

export function getRelatedVideos(videoId: string, limit = 6) {
  const current = getVideoById(videoId);
  if (!current) return videos.slice(0, limit);
  const sameCategory = videos.filter(
    (item) => item.id !== videoId && item.category === current.category
  );
  const sameTag = videos.filter(
    (item) =>
      item.id !== videoId &&
      item.category !== current.category &&
      (item.tags.genre === current.tags.genre || item.tags.region === current.tags.region)
  );
  return [...sameCategory, ...sameTag, ...videos.filter((item) => item.id !== videoId)]
    .filter((item, index, arr) => arr.findIndex((v) => v.id === item.id) === index)
    .slice(0, limit);
}

export function searchVideos(keyword: string) {
  const query = keyword.trim().toLowerCase();
  if (!query) return [];
  return videos.filter((item) => {
    const haystack = [
      item.title,
      item.categoryName,
      item.tags.region,
      item.tags.year,
      item.tags.language,
      item.tags.genre,
      item.description,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(query);
  });
}

export function sortVideos<T extends { playCount: number; uploadTime: string }>(
  list: T[],
  sort: string
): T[] {
  const copy = [...list];
  if (sort === "play") {
    return copy.sort((a, b) => b.playCount - a.playCount);
  }
  if (sort === "update") {
    return copy.sort((a, b) => b.uploadTime.localeCompare(a.uploadTime));
  }
  return copy.sort((a, b) => b.uploadTime.localeCompare(a.uploadTime));
}

export const yearOptions = ["全部", "2026", "2025", "2024"];
export const regionOptions = ["全部", "中国大陆", "中国香港", "日本", "韩国", "美国", "英国", "挪威"];
export const languageOptions = ["全部", "国语", "粤语", "日语", "韩语", "英语"];
export const sortOptions = [
  { value: "latest", label: "最新发布" },
  { value: "play", label: "最多播放" },
  { value: "update", label: "最近更新" },
];